import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

const TEST_PERSONAS = [
  "Amanda Boxall",
  "Andrew Zaidi",
  "Chloe Stretton",
  "Darryl Lewinson",
  "Diane Greenhalf",
  "Helen Whittington",
  "Martin Dykees",
  "Moray Prickett",
  "Nicole Larcombe",
  "Rebecca Bowen Eynon",
];

export const TestPersonaPickerDialog = ({ open, onClose, onSelect }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Select Test Persona</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Non-production environment detected. Select a test persona to use for
          this credit check instead of the sailor's actual details.
        </Typography>
        <List>
          {TEST_PERSONAS.map((name) => (
            <ListItemButton key={name} onClick={() => onSelect(name)}>
              <ListItemText primary={name} />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
